import React from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import Loadable from "react-loadable";
import "./App.scss";
import Login from "./views/Pages/Login/Login";
import Recover from "./views/Pages/Recover/Recover";
import auth from "./utils/authenticator";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/logout" component={logout} />
      <Route exact path="/recover" name="Recover Password" render={props => <Recover {...props}/>} />
      <Route exact path="/404" name="Page 404" component={Page404} />
      <Route exact path="/500" name="Page 500" component={Page500} />
      <PrivateRoute path="/" name="Home" component={DefaultLayout} />
    </Switch>
  </BrowserRouter>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = Loadable({
  loader: () => import("./containers/DefaultLayout"),
  loading,
});

const Page404 = Loadable({
  loader: () => import("./views/Pages/Page404"),
  loading,
});

const Page500 = Loadable({
  loader: () => import("./views/Pages/Page500"),
  loading,
});

// const logout = () => {
//   auth.signout(() => {
//     return  logoutredirect
//   });
// };

class logout extends React.Component {
  render() {
    auth.signout(() => {});
    setTimeout((window.location.href = "/login"), 1000);
    return true;
  }
}

export default Routes;
